'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import posthog from 'posthog-js';
import { redactTokenHashFromUrl } from '@/lib/utils/sentry-url-scrub';

export function PostHogPageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!pathname) return;
    if (typeof posthog.capture !== 'function') return;

    const qs = searchParams?.toString();
    const url =
      typeof window !== 'undefined'
        ? window.origin + pathname + (qs ? `?${qs}` : '')
        : pathname + (qs ? `?${qs}` : '');

    // The recovery link's token_hash is a live credential — never
    // ship it to analytics, even for the first pageview before the reset form
    // strips it from the address bar.
    posthog.capture('$pageview', { $current_url: redactTokenHashFromUrl(url) });
  }, [pathname, searchParams]);

  return null;
}
